import { CampaignType } from 'modules/domains/campaign';
import { ExperimentType } from 'modules/graphql';
import { useCampaignContext } from '../context';
import { getHasSendTimeOptimizationExperiment } from '../utils';

export const useSendTimeExperiment = () => {
  const { campaign } = useCampaignContext();
  const { experiments, campaignTypeDefinition } = campaign;

  const sendTimeExperiments = experiments?.filter(
    ({ experimentType }) => experimentType === ExperimentType.SendTime,
  );

  const hasSendTimeExperiment =
    !!sendTimeExperiments?.length && campaignTypeDefinition === CampaignType.Blast; // Send Time Experiments are only available for Blast campaigns currently

  const hasSendTimeOptimizationExperiment = getHasSendTimeOptimizationExperiment(campaign);

  return { hasSendTimeExperiment, hasSendTimeOptimizationExperiment, sendTimeExperiments };
};
